"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderPdfClient = void 0;

var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");

var _constants = require("../constants");

var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");

var OrderPdfClient = {
  getOrderPdfUrls: function getOrderPdfUrls() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        orderId = _ref.orderId,
        orderNumber = _ref.orderNumber;

    var requestId = 'ORDER_PDF_URL';
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ORDER_PDF_URL, {
      orderId: orderId,
      orderNumber: orderNumber
    });
    return _http.$http.get(requestId, endPoint).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  }
};
exports.OrderPdfClient = OrderPdfClient;